<div
  class="drag-boundary absolute left-0 top-0 h-full w-full"
  data-theme="dark"
>
  <div
    cdkDrag
    class="absolute bottom-6 left-6 z-50 flex h-10 select-none items-center justify-center gap-4 rounded-full bg-purple-700/60 pl-[10px] pr-3 text-bo-white"
    cdkDragBoundary=".drag-boundary"
  >
    <div class="flex gap-3">
      <input
        type="text"
        class="w-48 rounded-full bg-purple-400/50 px-2"
        placeholder="Object filter"
        (input)="filterChange($event)"
      />
      <svg-icon
        class="ml-2 self-center fill-white"
        [ngClass]="
          debugRenderService.showInfo() ? 'fill-white' : 'fill-white/50'
        "
        src="fa-icons/input-text.svg"
        [svgStyle]="{ 'height.px': 20 }"
        (click)="
          debugRenderService.showInfo.set(!debugRenderService.showInfo())
        "
      />
      <svg-icon
        class="ml-2 self-center fill-white"
        [ngClass]="
          debugRenderService.showCoordinates() ? 'fill-white' : 'fill-white/50'
        "
        src="fa-icons/arrows-up-down-left-right.svg"
        [svgStyle]="{ 'height.px': 20 }"
        (click)="
          debugRenderService.showCoordinates.set(
            !debugRenderService.showCoordinates()
          )
        "
      />
      <svg-icon
        class="ml-2 self-center fill-white"
        [ngClass]="appService.showOverlays() ? 'fill-white' : 'fill-white/50'"
        src="fa-icons/diagram-venn.svg"
        [svgStyle]="{ 'height.px': 20 }"
        (click)="appService.showOverlays.set(!appService.showOverlays())"
      />
      <svg-icon
        class="ml-2 self-center fill-white"
        src="fa-icons/eraser.svg"
        [svgStyle]="{ 'height.px': 20 }"
        (click)="appService.showUI.set(false)"
      />
      @if (workerPerformances().length > 1) {
        <svg-icon
          class="ml-2 self-center fill-white"
          [ngClass]="
            debugRenderService.coloredObjects() ? 'fill-white' : 'fill-white/50'
          "
          src="fa-icons/palette.svg"
          [svgStyle]="{ 'height.px': 20 }"
          (click)="
            debugRenderService.coloredObjects.set(
              !debugRenderService.coloredObjects()
            )
          "
        />
      }
      @if (debugRenderService.debugRegressions().length > 0) {
        <svg-icon
          class="ml-2 self-center fill-white"
          [ngClass]="showRegressions() ? 'fill-white' : 'fill-white/50'"
          src="fa-icons/traffic-light.svg"
          [svgStyle]="{ 'height.px': 20 }"
          (click)="showRegressions.set(!showRegressions())"
        />
      }
    </div>

    @if (workerPerformances().length > 0 && !showMetrics()) {
      <div class="flex border-l-2 border-white/30">
        <svg-icon
          class="ml-4 self-center fill-white"
          [src]="
            showPerformance()
              ? 'fa-icons/xmark.svg'
              : 'fa-icons/rabbit-running.svg'
          "
          [svgStyle]="{ 'height.px': 20 }"
          (click)="showPerformance.set(!showPerformance())"
        />
        @if (showPerformance()) {
          <div class="flex">
            @for (worker of workerPerformances(); track worker.id) {
              <div class="ml-3 flex items-center gap-2">
                <svg-icon
                  class="ml-2 self-center"
                  [src]="
                    debugRenderService.workerFilter.includes(worker.id)
                      ? 'fa-icons/toggle-off.svg'
                      : 'fa-icons/toggle-on.svg'
                  "
                  [svgStyle]="{
                    'height.px': 20,
                    fill:
                      this.debugRenderService.coloredObjects() ||
                      debugRenderService.workerFilter.includes(worker.id)
                        ? 'white'
                        : worker.color,
                  }"
                  (click)="toggleWorker(worker.id)"
                />
                <div class="flex text-small font-bold">
                  {{ worker.id }}:
                  <div class="flex w-[48px] justify-end">
                    {{ worker.cycleTime }} ms
                  </div>
                </div>
              </div>
            }
          </div>
        }
      </div>
    }
    @if (!showPerformance()) {
      <div class="flex border-l-2 border-white/30">
        <svg-icon
          class="ml-4 self-center fill-white"
          [src]="
            showMetrics() ? 'fa-icons/xmark.svg' : 'fa-icons/swap-arrows.svg'
          "
          [svgStyle]="{ 'height.px': 20 }"
          (click)="showMetrics.set(!showMetrics())"
        />
      </div>
    }
    @if (showMetrics()) {
      @if (toolPaths().length === 0) {
        No path metrics available
      }
      <div class="flex">
        @for (path of toolPaths(); track path; let first = $first) {
          <div class="flex items-center gap-2" [ngClass]="{ 'ml-3': !first }">
            <div class="flex text-small font-bold">
              {{ path.id }}:
              <div class="flex w-[24px] justify-end">
                {{ path.distance }}
              </div>
            </div>
          </div>
        }
      </div>
    }
  </div>
  @if (showRegressions() && debugRenderService.debugRegressions().length > 0) {
    <div
      cdkDrag
      class="absolute bottom-20 left-6 z-50 flex select-none items-center justify-center rounded-lg bg-purple-700/60 p-2 text-small text-bo-white"
      cdkDragBoundary=".drag-boundary"
    >
      <div>
        @for (
          worker of debugRenderService.debugRegressions();
          track worker.workerId
        ) {
          <div>
            <div class="font-bold">{{ worker.workerId }}</div>
            @for (regression of worker.regressions; track regression.name) {
              <div class="flex w-full justify-between">
                <div>{{ regression.name }}</div>
                <div class="flex w-14 items-center justify-between pl-3">
                  <div class="w-6">{{ regression.confidence }}</div>
                  <div
                    class="mt-1 size-3 rounded-full"
                    [ngClass]="{
                      'bg-green-600': regression.confidence > 0.66,
                      'bg-yellow-400':
                        regression.confidence > 0.33 &&
                        regression.confidence <= 0.66,
                      'bg-red-600': regression.confidence <= 0.33,
                    }"
                  ></div>
                </div>
              </div>
            }
          </div>
        }
      </div>
    </div>
  }
</div>
